enum AlertSeverity {
    Information = 0,
    Warning = 1,
    Error = 2,
    Critical = 3
}
export default AlertSeverity;
